module.exports = __webpack_public_path__ + "img/2.3c886dd5.jpg";